// Angular Files
import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

// Angular Material Files
import { MatButtonModule } from '@angular/material/button';

// Teller Online Library Files
import { TellerOnlineAppService } from 'teller-online-libraries/core';

export const LOAD_ERROR_PATH = '/load-error';

/**
 * Shown in place of a page whose data or code failed to load (AppComponent sends a failed
 * navigation here), so a failed load never leaves a blank page. It is routed eagerly rather
 * than lazy-loaded: the page that reports a failed load can't itself depend on loading a chunk.
 */
@Component({
    selector: 'app-load-error',
    templateUrl: './load-error.component.html',
    styleUrls: ['./load-error.component.scss'],
    host: {
        class: 'load-error-view'
    },
    imports: [RouterLink, MatButtonModule]
})
export class LoadErrorComponent implements OnInit {
    private _failedUrl: string;

    constructor(
        private router: Router,
        public appService: TellerOnlineAppService
    ) {
        // The navigation's state only exists while the navigation that brought us here runs
        this._failedUrl = this.router.currentNavigation()?.extras.state?.failedUrl ?? '/';
    }

    ngOnInit() {
        this.appService.finishPageLoading();
    }

    onClick_retry() {
        this.router.navigateByUrl(this._failedUrl);
    }
}
